import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';


export const controlButtonSize = 36;
export const constrolButtonSizeMini = 24;

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    controlButton: {
      backgroundColor: theme.palette.background.default,
      width: controlButtonSize,
      height: controlButtonSize,
      '&:hover': {
        background: theme.palette.grey.A100,
      }
    },
    controlButtonMini: {
      width: constrolButtonSizeMini,
      height: constrolButtonSizeMini,
    },
    controlButtonHidden: {
      visibility: "hidden",
    },
  }),
);


export default useStyles;
